import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col } from 'styled-bootstrap-grid'
import { compose } from 'react-apollo'
import { Link } from 'react-router-dom'
import moment from 'moment'

import getRelativeUrl from 'utils/getRelativeUrl'
import { Text } from 'ui/styles/utils'
import FadeEntry from 'ui/components/generic/FadeEntry'
import withConcerts from 'containers/withConcerts'

const Wrapper = styled.div`
  position: relative;
  padding: 50px 0;
`

const Concert = styled.div`
  margin-bottom: 100px;
`

const Date = Text.extend`
  font-family: ${props => props.theme.displayFont};
  line-height: 1 !important;
  color: #fff;
`

const Details = styled.div`
  font-family: ${props => props.theme.displayFont};
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  margin-bottom: 20px;
`

const Title = Text.extend`
  span {
    display: inline-block;
    margin-right: 10px;
  }

  a {
    color: #fff;
    font-family: ${props => props.theme.displayFont};
  }
`

const ConcertLinks = styled.div`
  a {
    font-size: 14px;
    font-weight: bold;
    margin-left: 10px;
    color: #fff;
    opacity: 0.8;
  }
`

const Setup = styled(Text).attrs({ size: 'sm' })`
  display: inline-block;
  margin-right: 10px;
  opacity: 0.6;
`

const PastConcerts = styled.div`
  color: #fff;

  ${Concert} {
    opacity: 0.8;
  }
`

const TicketStatus = styled.div`
  padding: 4px 8px;
  background-color: #fff;
  color: #000;
  display: inline-block;
  text-transform: uppercase;
  font-weight: 700;
  font-family: ${props => props.theme.bodyFont};
  margin-right: 10px;
  font-size: 10px;
  line-height: 10px;
  transform: translateY(-25%);
`

class TourDates extends Component {
  render() {
    const { concerts, pastConcerts } = this.props

    return (
      <Container fluid>
        <Wrapper>
          {concerts &&
            concerts.sort().map(concert => (
              <FadeEntry amount={20} direction="left">
                <Row>
                  <Col sm={10} smOffset={1} md={8} mdOffset={2}>
                    <Concert>
                      <Details>
                        <Date size="md">
                          {moment(concert.concertDate).format('MMMM D YYYY')}
                        </Date>
                        <ConcertLinks>
                          {concert.ticketLink && (
                            <a href={concert.ticketLink}>Tickets</a>
                          )}
                        </ConcertLinks>
                      </Details>
                      <Title>
                        <Link to={getRelativeUrl(concert.link)}>
                          <span>{concert.title}</span>
                          {concert.setup && (
                            <Setup>
                              (
                              {concert.setup.tourCalendarTitle ||
                                concert.setup.title}
                              )
                            </Setup>
                          )}
                          {concert.ticketStatus && (
                            <TicketStatus
                              dangerouslySetInnerHTML={{
                                __html: concert.ticketStatus
                              }}
                            />
                          )}
                        </Link>
                      </Title>
                    </Concert>
                  </Col>
                </Row>
              </FadeEntry>
            ))}
          <PastConcerts>
            <Row>
              <Col sm={10} smOffset={1} md={8} mdOffset={2}>
                <FadeEntry amount={20} direction="left">
                  <h2>
                    <Text size="lg">Past shows</Text>
                  </h2>
                </FadeEntry>
              </Col>
            </Row>
            {pastConcerts &&
              pastConcerts.sort().map(concert => (
                <FadeEntry amount={20} direction="left">
                  <Row>
                    <Col sm={10} smOffset={1} md={8} mdOffset={2}>
                      <Concert>
                        <Details>
                          <Date size="md">
                            {moment(concert.concertDate).format('MMMM D YYYY')}
                          </Date>
                          {concert.ticketStatus && (
                            <TicketStatus
                              dangerouslySetInnerHTML={{
                                __html: concert.ticketStatus
                              }}
                            />
                          )}
                        </Details>
                        <Title>
                          <Link to={getRelativeUrl(concert.link)}>
                            <span>{concert.title}</span>
                            {concert.setup && (
                              <Setup>
                                {concert.setup.tourCalendarTitle ||
                                  concert.setup.title}
                              </Setup>
                            )}
                          </Link>
                        </Title>
                      </Concert>
                    </Col>
                  </Row>
                </FadeEntry>
              ))}
          </PastConcerts>
        </Wrapper>
      </Container>
    )
  }
}

export default compose(
  withConcerts(),
  withConcerts(false, 'pastConcerts')
)(TourDates)



// WEBPACK FOOTER //
// ./src/ui/components/modules/TourDates/index.js